import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BrandingService } from '../../core/services/branding.service';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { PagesService } from '../../core/services/pages.service';
import { Subscription } from 'rxjs';
import { AboutUsContent } from '../shared-components.model';

@Component({
    selector: 'app-about-us-page',
    templateUrl: './about-us-page.component.html',
    styleUrls: ['./about-us-page.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AboutUsPageComponent implements OnInit, OnDestroy {
  pageContent: SafeHtml | null = null;
  loading: boolean = true;
  subscription: Subscription = new Subscription();

  constructor(
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private brandingService: BrandingService,
    private pagesService: PagesService
  ) {}

  ngOnInit(): void {
    this.brandingService.setBrandingTitle('About Us');
    this.getPageContent();
  }

  getPageContent(): void {
    const pageTitle = this.activatedRoute.snapshot.data['pageTitle'];
    this.subscription.add(this.brandingService.getPageByTitle(pageTitle).pipe(
      tap(() => this.loading = true),
      filter(v => !!v),
      map(v => v.id),
      switchMap((id) => this.pagesService.getPage(id)),
      map((v: AboutUsContent) => v.content)
    ).subscribe((pageContent: string) => {
      this.loading = false;
      this.pageContent = this.sanitizer.bypassSecurityTrustHtml(pageContent);
    }));
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
